export default __webpack_public_path__ + "images/models/85e5b78c5d731aa7655ce3d175e915a2.usdz";